import {
  auth,
  firestore,
  firestoreDb,
  storageRef,
  functions,
} from "@/config/firebase";
import { showMessage } from "@/services/MessageService";
import { i18n } from "@/i18n";
import { SponsorData } from "@/models/events/sponsors/sponsorData";
export default {
  /**
   * Get event information about sponsors
   * Receives the event identifier as a parameter: event
   * Used in SponsorsDetails view in /components/sponsors/SponsorsDetails.vue
   */
  async getSponsors({ _ }: any, eventID) {
    try {
      const SponsorsSnap = await firestoreDb
        .collection("events")
        .doc(eventID)
        .collection("sponsors")
        .get();
      const sponsorsArray: Array<SponsorData> = [];
      for (const sponsor of SponsorsSnap.docs) {
        sponsorsArray.push(sponsor.data() as SponsorData);
      }
      return sponsorsArray;
    } catch (e) {
      showMessage({
        title: i18n.global.t("sponsors.obtainSponsorsInfoError.title"),
        message: i18n.global.t("sponsors.obtainSponsorsInfoError.message"),
        type: "error",
      });
      return null;
    }
  },
};
